// extracted by mini-css-extract-plugin
export var growableInput = "_8z-0";
export var tagContainer = "_8z-2";
export var textInput = "_8z-1";